import { useRouter } from 'next/router';
import styled from '@emotion/styled';
import Paper from '@base/Paper/Paper';
import { mediaQuery, Spacings } from '@styles/index';
import H4 from '@base/H4/H4';
import H5 from '@base/H5/H5';
import P1 from '@base/P1/P1';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { getTopologyDataByUID } from '@selectors/topologies';

const Wrapper = styled.div`
  margin-top: ${Spacings.SPACING_14B};
  grid-column: span 24;
  display: flex;
  justify-content: space-between;

  ${mediaQuery.uptoTablet} {
    grid-column: auto;
    width: 100%;
    margin-top: ${Spacings.SPACING_4B};
    flex-flow: column;
  }
`;

const Heading = styled(H4)`
  padding-left: ${Spacings.SPACING_12B};

  ${mediaQuery.uptoTablet} {
    padding-left: ${Spacings.SPACING_4B};
  }
`;

const SubjectWrapper = styled(Paper)`
  padding: ${Spacings.SPACING_8B};
  padding-bottom: 0;
  margin: ${Spacings.SPACING_6B} 0;
  width: 65%;

  ${mediaQuery.uptoTablet} {
    width: 100%;
  }
`;

const ListWrapper = styled.div`
  margin-bottom: ${Spacings.SPACING_6B};
`;

const SubjectName = styled(H5)`
  padding-bottom: ${Spacings.SPACING_4B};
`;

const StyledP1 = styled(P1)`
  padding-bottom: ${Spacings.SPACING_2B};
`;

const Syllabus = () => {
  const { query } = useRouter();
  const { goalUID } = query;

  const goalDetails = useSelectorWithShallowEqual(
    getTopologyDataByUID(goalUID)
  );

  return (
    <Wrapper>
      <Heading>Syllabus</Heading>
      <SubjectWrapper>
        <ListWrapper>
          <SubjectName>{goalDetails.name}</SubjectName>
          <StyledP1>Complete syllabus</StyledP1>
        </ListWrapper>
      </SubjectWrapper>
    </Wrapper>
  );
};

export default Syllabus;
